import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpResponse,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable()
export class CsrfTokenInterceptor implements HttpInterceptor {
  private csrfToken: string | null = null;

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // Add CSRF token to request if we have one
    if (this.csrfToken && this.shouldIncludeToken(req)) {
      req = req.clone({
        setHeaders: {
          'X-CSRF-TOKEN': this.csrfToken,
        },
      });
    }

    // Capture CSRF token from response headers
    return next.handle(req).pipe(
      tap((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          this.extractCsrfToken(event.headers);
        }
      })
    );
  }

  /**
   * Extract CSRF token from response headers
   * Common header names: X-CSRF-TOKEN, X-XSRF-TOKEN, XSRF-TOKEN
   */
  private extractCsrfToken(headers: any): void {
    // Try standard CSRF header names
    let token =
      headers.get('X-CSRF-TOKEN') ||
      headers.get('X-XSRF-TOKEN') ||
      headers.get('XSRF-TOKEN');

    // If not found in headers, try to extract from Set-Cookie
    if (!token) {
      const cookieHeader = headers.get('Set-Cookie');
      if (cookieHeader) {
        const match = cookieHeader.match(/XSRF-TOKEN=([^;]+)/);
        if (match && match[1]) {
          token = match[1];
        }
      }
    }

    if (token) {
      this.csrfToken = token;
      console.debug(
        '[CSRF Interceptor] CSRF token extracted:',
        token.substring(0, 20) + '...'
      );
    }
  }

  /**
   * Determine if request should include CSRF token
   * (e.g., skip for GET requests, only include for state-changing requests)
   */
  private shouldIncludeToken(req: HttpRequest<any>): boolean {
    const method = req.method.toUpperCase();
    // Include CSRF token for requests that modify state
    return ['POST', 'PUT', 'PATCH', 'DELETE'].includes(method);
  }
}
